/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActualAssetClassExposureMaxLimitViewModel
 */
export interface ActualAssetClassExposureMaxLimitViewModel {
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureMaxLimitViewModel
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureMaxLimitViewModel
     */
    equity?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureMaxLimitViewModel
     */
    property?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureMaxLimitViewModel
     */
    bonds?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureMaxLimitViewModel
     */
    cash?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureMaxLimitViewModel
     */
    hedge?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureMaxLimitViewModel
     */
    privateEquity?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureMaxLimitViewModel
     */
    commodities?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureMaxLimitViewModel
     */
    other?: number;
}

/**
 * Check if a given object implements the ActualAssetClassExposureMaxLimitViewModel interface.
 */
export function instanceOfActualAssetClassExposureMaxLimitViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ActualAssetClassExposureMaxLimitViewModelFromJSON(json: any): ActualAssetClassExposureMaxLimitViewModel {
    return ActualAssetClassExposureMaxLimitViewModelFromJSONTyped(json, false);
}

export function ActualAssetClassExposureMaxLimitViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActualAssetClassExposureMaxLimitViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'percentage': !exists(json, 'Percentage') ? undefined : json['Percentage'],
        'equity': !exists(json, 'Equity') ? undefined : json['Equity'],
        'property': !exists(json, 'Property') ? undefined : json['Property'],
        'bonds': !exists(json, 'Bonds') ? undefined : json['Bonds'],
        'cash': !exists(json, 'Cash') ? undefined : json['Cash'],
        'hedge': !exists(json, 'Hedge') ? undefined : json['Hedge'],
        'privateEquity': !exists(json, 'PrivateEquity') ? undefined : json['PrivateEquity'],
        'commodities': !exists(json, 'Commodities') ? undefined : json['Commodities'],
        'other': !exists(json, 'Other') ? undefined : json['Other'],
    };
}

export function ActualAssetClassExposureMaxLimitViewModelToJSON(value?: ActualAssetClassExposureMaxLimitViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Percentage': value.percentage,
        'Equity': value.equity,
        'Property': value.property,
        'Bonds': value.bonds,
        'Cash': value.cash,
        'Hedge': value.hedge,
        'PrivateEquity': value.privateEquity,
        'Commodities': value.commodities,
        'Other': value.other,
    };
}

